'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'files';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e178';
var svgPathData = 'M144 368l256 0 0-240-80 0 0-80L144 48l0 320zM352 0l96 96 0 272 0 48-48 0-256 0-48 0 0-48L96 48 96 0l48 0L352 0zM48 96l0 24 0 344 280 0 24 0 0 48-24 0L24 512 0 512l0-24L0 120 0 96l48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFiles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;